var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"mr-1 border border-solid",class:{'text-dark': !_vm.backgroundColor, 'border-none': _vm.backgroundColor},attrs:{"color":_vm.backgroundColor || 'white'}},[_c('AnchoredTitle',{attrs:{"title":_vm.title}}),(_vm.showCount)?_c('span',{staticClass:"ml-1"},[_vm._v("("+_vm._s(_vm.count)+"x)")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }